// @flow

import { gql } from "@apollo/client";
import { graphql } from "@apollo/client/react/hoc";

const markCustomsShipmentAsArchived: any = graphql(
  gql`
    mutation ($customsShipmentId: ID!) {
      markCustomsShipmentAsArchived(customsShipmentId: $customsShipmentId) {
        errors {
          customsShipmentId
        }
        updatedCustomsShipment {
          id
          canonicalId
          createdAt
          shippedOn
          archivedOn
          controlNumber
          canViewerMarkAsShipped
          canViewerMarkAsArchived
          canViewerSetControlNumber
        }
        succeeded
      }
    }
  `,
  {
    name: "markCustomsShipmentAsArchived"
  }
);

export default markCustomsShipmentAsArchived;
